export default __webpack_public_path__ + "media/images/users/user-jim-smith-70x70-124c836a5bdb67afebe46593fbf0d678.jpg";